import { EventEmitter } from "@angular/core";

export abstract class LoginServiceBase {
  public LoginStatusChanged = new EventEmitter<any>();
  public OrganizationChanged = new EventEmitter<any>();
  public RequiresPasswordReset: boolean = false;
  public OrganizationDeleted = new EventEmitter<any>();

  public abstract IsLoggedIn(): boolean;
  public abstract LoggedInName(): string;
  public abstract LoggedInNameChanged(firstName: string, lastName: string): void;
  public abstract CurrentToken(): string;
  public abstract CurrentOrganizationId(): string;
  public abstract UserId(): string;
  public abstract DoLogin(username: string, password: string): Promise<any>;
  public abstract DoLogout(): Promise<void>;
  public abstract DoOrganizationSwitch(id: string): void;
  public abstract NewTestOrganization(name: string): void;
  public abstract DeleteNewTestOrganization(name: string): void;
  public abstract NotifyAuthExpired(): void;
  public abstract DebugBreakAuthToken(): void;
}
